<template lang="pug">
span
  button.btn-prev.disabled(type='button', v-if='$parent.$parent.internalCurrentPage <= 1')
    i.el-icon.el-icon-arrow-left
  a(:href="buildURL($parent.$parent.internalCurrentPage - 1)", v-else, @click.prevent='goTo($parent.$parent.internalCurrentPage - 1)')
    button.btn-prev(type='button')
      i.el-icon.el-icon-arrow-left
  pager(:currentPage="$parent.$parent.internalCurrentPage", :pageCount="$parent.$parent.internalPageCount", @change="$parent.$parent.$parent.handleCurrentChange")
  button.btn-next.disabled(type='button', v-if='$parent.$parent.internalCurrentPage === $parent.$parent.internalPageCount || $parent.$parent.internalPageCount === 0')
    i.el-icon.el-icon-arrow-right
  a(:href="buildURL($parent.$parent.internalCurrentPage + 1)", v-else, @click.prevent='goTo($parent.$parent.internalCurrentPage + 1)')
    button.btn-next(type='button',)
      i.el-icon.el-icon-arrow-right
</template>

<script>
import Pager from 'element-ui/packages/pagination/src/pager'

export default {
  props: [
    'goTo'
  ],
  store: window.store,
  components: {
    Pager
  },
  data () {
    return {
      base: null
    }
  },
  created () {
    const url = new URL(window.location)
    this.base = `${url.origin}${url.pathname}`
  },
  methods: {
    buildURL (value) {
      const params = new URLSearchParams(new URL(window.location).search)
      params.set('page', value)
      return `${this.base}?${params.toString()}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom-pagination.vue